import { Alert } from "@/components/ui/alert";
import { Link } from "react-router-dom";
import { translate } from '../../../utils/Common';

const SignUpSuccess = () => {
    return  <div>
                <Alert variant='success' className="font-normal mb-4 mt-3">
                    <div>
                        <h6>{translate("login.signup.success.title")}</h6>
                        <div className="text-center">
                            <p className="mb-2">{translate("login.signup.success.description1")} <span className="font-semibold">#{translate("login.signup.success.description2")}.</span></p>
                            <p className="mb-2">{translate("login.signup.success.description3")}.</p>
                        </div>
                    </div>
                </Alert>
                <Link to="/"><button className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 btn-outline-blue btn-signup rounded-pill uppercase m-2">{translate("login.signup.success.return")}</button></Link>
            </div>
}

export default SignUpSuccess;